import React, { useEffect } from "react";
import { useExclusionsStore } from "./stores/exclusionsStore";
import ExclusionsTable from "./components/ExclusionsTable";
import ExclusionForm from "./components/ExclusionForm";
import { PermissionWrapper, SearchBar, Loading, PageHistory } from "components";
import { exclusionHistoryConfig } from "./utils/exclusionHistoryConfig";

// Головний компонент сторінки "Виключення"
const ExclusionsPage = () => {
  // Отримуємо необхідні дані та дії зі стору
  const exclusions = useExclusionsStore((state) => state.exclusions);
  const isLoading = useExclusionsStore((state) => state.isLoading);
  const filters = useExclusionsStore((state) => state.filters);
  const setSearch = useExclusionsStore((state) => state.setSearch);
  const upsertExclusion = useExclusionsStore((state) => state.upsertExclusion);
  const deleteExclusion = useExclusionsStore((state) => state.deleteExclusion);
  const init = useExclusionsStore((state) => state.init);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки
  useEffect(() => {
    init();
  }, [init]);

  return (
    <section id="exclusions">
      <PermissionWrapper requiredPermission="activity_log:view">
        <PageHistory subjects={["exclusion_price"]} config={exclusionHistoryConfig} />
      </PermissionWrapper>
      <div className="page-container">
        <div className="exclusions-title">
          <div className="exclusions-title-line">
            <h3>Таблиця виключень</h3>
            <SearchBar
              value={filters.search}
              onSearch={(value) => setSearch(value)}
            />
          </div>
          <PermissionWrapper requiredPermission="exclusions:edit">
            <div className="exclusions-title-line">
              <ExclusionForm onAdd={upsertExclusion} />
            </div>
          </PermissionWrapper>
        </div>

        {isLoading ? (
          <Loading />
        ) : (
          <ExclusionsTable
            exclusions={exclusions}
            onDelete={deleteExclusion}
            onUpdatePrice={upsertExclusion}
          />
        )}
      </div>
    </section>
  );
};

export default ExclusionsPage;
